import SubscriptionOrgList from "./SubscriptionOrgList";

export default SubscriptionOrgList;
